import { useTranslation } from "../contexts/TranslationContext";
import { Step, Divider } from "../components/Process";

const WorkingProcess = () => {
  const { t } = useTranslation();
  return (
    <section className={'bg-defaultBg'}>
      <div className={'container mx-auto px-4 pt-8 pb-16'}>
        <h2 className={'text-2xl font-bold mb-8'}>
          {t('easyWorkingProcess')}
        </h2>

        <div className={'grid lg:grid-cols-5 items-center'}>
          <Step stepNumber={1} translationKey={t('createForm')} />
          <Divider />
          <Step stepNumber={2} translationKey={t('manageSubmission')} />
          <Divider />
          <Step stepNumber={3} translationKey={t('shareResults')} />
        </div>
      </div>
    </section>
  );
}

export default WorkingProcess;